<div class="spinner-container tw:flex tw:justify-center tw:items-center">
  <div class="tw:flex tw:flex-wrap tw:my-auto" style="max-height: 250px;">
    <div class="tw:w-full">
      <mat-progress-spinner [mode]="'indeterminate'">
      </mat-progress-spinner>
    </div>
    @if (showHint && spinnerService.hints && spinnerService.hints.length > 0 && shotHintOverwrite) {
      <div class="tw:w-full tw:mt-2 tw:text-center" @fade>
        <label class="spinner-hint-label"> <b>Pro Tip:</b> {{hint}}</label>
      </div>
    }
  </div>
</div>